export const getPlan = /* GraphQL */ `
  query GetPlan($id: String!) {
    getPlan(id: $id)
  }
`;
